import apiClient, { API_BASE_URL } from './apiConfig';

// Export the API client for use in other services
const api = apiClient;

export const registrationAPI = {
  // Register a new participant
  registerParticipant: async (formData) => {
    try {
      const response = await api.post('/register', formData);
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || 
        error.response?.data?.errors?.join(', ') || 
        'Registration failed'
      );
    }
  },

  // Get fee calculation
  getFeeCalculation: async (participantType) => {
    try {
      const response = await api.get(`/fee-calculation?participant_type=${participantType}`);
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || 
        'Failed to calculate fee'
      );
    }
  },

  // Get all registrations (admin)
  getAllRegistrations: async () => {
    try {
      const response = await api.get('/registrations');
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || 
        'Failed to fetch registrations'
      );
    }
  },

  // Get specific registration
  getRegistrationById: async (id) => {
    try {
      const response = await api.get(`/registrations/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message || 
        'Failed to fetch registration'
      );
    }
  },

  // Health check
  healthCheck: async () => {
    try {
      const response = await api.get('/health');
      return response.data;
    } catch (error) {
      throw new Error('API health check failed');
    }
  }
};

export default api;
